<template lang="pug">
    .howtojoin.page-bottom
        .howtojoin__inner
            DynamicLink(:to="btn_url", :title="btn", class="button button-rounded howtojoin__btn") {{btn}}
            .howtojoin__col
                .howtojoin__header(v-html="header")
                    | #{header}
                .howtojoin__body(v-html="body")
                    | #{body}
            .howtojoin__col
                img(v-bind="cover.default").howtojoin__img
</template>

<script>
    import DynamicLink from './DynamicLink';
    export default {
        name: "WidgetHowToJoin",
        components: {DynamicLink},
        props: {
            cover: Object,
            header: String,
            body: String,
            btn: String,
            btn_url: String
        }
    };
</script>


<style lang="sass" scoped>
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../assets/styles/CustomVariables"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    // @import "../../node_modules/bootstrap/scss/reboot"
    @import "../../node_modules/bootstrap/scss/grid"
    $color-blue: #03d3bf
    .howtojoin
        padding: 5rem 0
        margin-top: 6rem
        background: #ebebeb
        position: relative
        @include media-breakpoint-down(md)
            padding-top: 2rem
            padding-bottom: 2rem
            margin-top: 2rem

        &__inner
            position: relative
            @extend .container
            @include media-breakpoint-down(md)
                display: flex
                flex-wrap: wrap-reverse
                padding-left: 15px
                padding-right: 15px

        &__col
            position: relative
            display: inline-block
            width: 50%
            vertical-align: top
            @include media-breakpoint-between(md, lg)
                &:first-of-type
                    padding-bottom: 4rem
            @include media-breakpoint-down(md)
                width: 100%

        &__header
            margin-bottom: 1.5rem
            font-size: 1.9rem
            font-weight: bold
            color: $color-blue
            @include media-breakpoint-down(md)
                margin-top: 1rem
                margin-bottom: 1rem
                font-size: 1.56rem

        &__body
            line-height: normal
            font-size: 1.25rem
            margin-bottom: 3rem
            @include media-breakpoint-down(md)
                margin-bottom: 4rem
                font-size: 1rem

        &__btn
            position: absolute
            bottom: 0
            border-radius: 2rem
            padding: 1rem 5rem
            text-align: center
            font-size: 1.125rem
            background: #03d3bf
            border: 1px solid #03d3bf
            color: white
            font-weight: bold
            z-index: 999
            &:before
                display: block
                content: " "
                position: absolute
                z-index: 1
                background: black
                border-radius: 2rem
                top: 0
                left: 0
                right: 0
                bottom: 0
                opacity: 0
                transition: opacity .25s
            &:hover:before
                opacity: 0.1
            &:hover
                text-decoration: underline
            @include media-breakpoint-down(md)
                width: 95%
                padding: .5rem 2.5rem
            @include media-breakpoint-down(sm)
                width: 93%
</style>

